import { Builder } from '@builder.io/react'
import { LinkButtonRegisterProps } from 'components/ui-builder/common/button'
import CdnImage from 'components/util/CdnImage'
// import CloudinaryImage from 'components/util/CloudinaryImage'
import { Link } from 'gatsby'
import React from 'react'
import { LinkButtonProp } from '../common/button'

interface Props {
  backgroundColor: string
  titleOne: string
  titleOneBold: string
  titleTwo: string
  titleTwoBold: string
  imageOne: any
  imageOneAltText: string
  imageTwo: any
  imageTwoAltText: string
  builderImageOne: string
  builderImageTwo: string
  headingTextOne: string
  contentTextOne: string
  headingTextTwo: string
  contentTextTwo: string
  buttonOneEnabled: boolean
  buttonTwoEnabled: boolean
  buttonOneProp: LinkButtonProp
  buttonTwoProp: LinkButtonProp
  backgroundColorOne: string
  backgroundColorTwo: string
}

const LinksTwo = ({
  backgroundColor,
  titleOne,
  titleOneBold,
  titleTwo,
  titleTwoBold,
  imageOne,
  imageOneAltText,
  imageTwo,
  imageTwoAltText,
  builderImageOne,
  builderImageTwo,
  headingTextOne,
  contentTextOne,
  headingTextTwo,
  contentTextTwo,
  buttonOneEnabled,
  buttonTwoEnabled,
  buttonOneProp,
  buttonTwoProp,
  backgroundColorOne,
  backgroundColorTwo
}: Props) => {
  const renderCTAButton = (buttonEnabled: boolean, buttonText: string, buttonUrl: string) => {
    if (buttonEnabled) {
      return (
        <Link
          target="_blank"
          rel="noopener"
          to={`${buttonUrl}`}
          className={`mx-auto flex w-full items-center justify-center rounded-full border border-[#006685] bg-[#ffffff] px-5 py-3 text-base font-bold text-[#006685] md:mt-8 md:w-96 md:text-lg lg:w-4/5`}
          onClick={() => {
            if (typeof window.gtag !== 'undefined') {
              window.gtag('event', 'cta_component_links_cta_logged_in', {
                page: 'home_page_logged_in'
              })
            }
          }}
        >
          {buttonText}
        </Link>
      )
    }

    return null
  }
  return (
    <div
      className="bg-image-none relative h-full w-full md:bg-cover md:bg-bottom md:bg-no-repeat"
      style={{ backgroundColor }}
    >
      <div className="mx-auto flex flex-col-reverse lg:flex-row lg:container gap-10 ">
        {/* Section one */}
        <div className="w-full lg:w-1/2 flex flex-col">
          <div className="text-center pb-8">
            <span className="text-[#004355] text-[32px] font-medium font-serif">{titleOne}</span>
            <span className="text-[#004355] text-[32px] font-medium font-serif"> {titleOneBold}</span>
          </div>
          <div className="relative w-full px-4 lg:w-[30rem] 2xl:w-[38rem] lg:px-0 mx-auto">
            <CdnImage
              className="index-2 h-56 w-full rounded-2xl object-cover"
              url={builderImageOne}
              alt={imageOneAltText}
              steps={[1080]}
              width={'500'}
            />

            {/* {builderImageOne ? (
              <CdnImage
                className="index-2 h-56 w-full rounded-2xl object-cover"
                url={builderImageOne}
                alt={imageOneAltText}
                steps={[1080]}
                width={'500'}
              />
            ) : (
              <CloudinaryImage
                className="index-2 h-56 w-full rounded-2xl object-cover"
                publicId={imageOne?.public_id}
                alt={imageOneAltText}
                steps={[1080]}
                width={500}
              /> */}
            {/* )} */}
          </div>
          <div className="relative mx-auto w-full lg:w-[30rem] 2xl:w-[38rem] bg-contain bg-top bg-no-repeat block">
            <div className="w-full lg:w-[30rem] 2xl:w-[38rem] mx-auto flex flex-col justify-center items-center">
              <div className="text-[#004355] leading-10 text-[28px] font-semibold font-sans py-4 lg:py-8 text-center px-1 lg:px-0">
                {headingTextOne}
              </div>
              <p
                className={`w-11/12 enable-list-styles text-sm font-medium font-sans text-center -mt-2 lg:-mt-4 2xl:-mt-6`}
                dangerouslySetInnerHTML={{ __html: contentTextOne }}
              ></p>{' '}
              <div className="mt-4 lg:my-2 mx-auto w-3/5">
                {renderCTAButton(buttonOneEnabled, `${buttonOneProp.loggedInButtonText}`, `${buttonOneProp.buttonUrl}`)}
              </div>
            </div>
          </div>
        </div>
        {/* Section two */}
        <div className="w-full lg:w-1/2 flex flex-col">
          <div className="text-center pb-8">
            <span className="text-[#004355] text-[32px] font-medium font-serif">{titleTwo}</span>
            <span className="text-[#004355] text-[32px] font-medium font-serif"> {titleTwoBold}</span>
          </div>
          <div className="relative w-full px-4 lg:w-[30rem] 2xl:w-[38rem] lg:px-0 mx-auto">
            <CdnImage
              className="index-2 h-56 w-full rounded-2xl object-cover"
              url={builderImageTwo}
              alt={imageTwoAltText}
              steps={[1080]}
              width={'500'}
            />

            {/* {builderImageTwo ? (
              <CdnImage
                className="index-2 h-56 w-full rounded-2xl object-cover"
                url={builderImageTwo}
                alt={imageTwoAltText}
                steps={[1080]}
                width={'500'}
              />
            ) : (
              <CloudinaryImage
                className="index-2 h-56 w-full rounded-2xl object-cover"
                publicId={imageTwo?.public_id}
                alt={imageTwoAltText}
                steps={[1080]}
                width={500}
              />
            )} */}
          </div>
          <div className="relative mx-auto w-full lg:w-[30rem] 2xl:w-[38rem] bg-contain bg-top bg-no-repeat block">
            <div className="w-full lg:w-[30rem] 2xl:w-[38rem] mx-auto flex flex-col justify-center items-center">
              <div className="text-[#004355] text-[28px] font-semibold font-sans py-4 lg:py-8 text-center">
                {headingTextTwo}
              </div>
              <p
                className={`w-11/12 enable-list-styles text-sm font-medium font-sans text-center -mt-2 lg:-mt-4 2xl:-mt-6`}
                dangerouslySetInnerHTML={{ __html: contentTextTwo }}
              ></p>{' '}
              <div className="mt-4 lg:my-2 mx-auto w-3/5">
                {renderCTAButton(buttonTwoEnabled, `${buttonTwoProp.loggedInButtonText}`, `${buttonTwoProp.buttonUrl}`)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LinksTwo
Builder.registerComponent(LinksTwo, {
  name: 'LinksTwo',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'titleOne',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'titleOneBold',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'titleTwo',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'titleTwoBold',
      type: 'text',
      defaultValue: ''
    },
    // {
    //   name: 'imageOne',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'imageOneAltText',
      type: 'text',
      defaultValue: ''
    },
    // {
    //   name: 'imageTwo',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'imageTwoAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'builderImageOne',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'builderImageTwo',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'headingTextOne',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'contentTextOne',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'headingTextTwo',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'contentTextTwo',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'buttonOneEnabled',
      type: 'boolean',
      defaultValue: false
    },
    {
      ...LinkButtonRegisterProps,
      name: 'buttonOneProp'
    },
    {
      name: 'buttonTwoEnabled',
      type: 'boolean',
      defaultValue: false
    },
    {
      ...LinkButtonRegisterProps,
      name: 'buttonTwoProp'
    },
    {
      name: 'backgroundColorOne',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'backgroundColorTwo',
      type: 'color',
      defaultValue: 'white'
    }
  ]
})
